import { classEnum } from "./base";

export const RegistrationStatusEnum = new (class extends classEnum([
    {
        label: "Registrasi",
        value: "R",
    },
    {
        label: "Survei",
        value: "S",
    },
    {
        label: "Setup Akun",
        value: "A",
    },
    {
        label: "Setup Produk",
        value: "P",
    },
    {
        label: "Instalasi",
        value: "I",
    },
    {
        label: "Finalisasi",
        value: "F",
    },
    {
        label: "Dibatalkan",
        value: "C",
    },
    {
        label: "Selesai",
        value: "D",
    },
]) {
    public get valuesOngoing() {
        return this.values.filter((v) => v !== "C" && v !== "D");
    }

    public get ValuesOngoing(): this["valuesOngoing"][number] {
        throw new Error("ValuesOngoing can't be used as a value");
    }
})();

export namespace RegistrationStatusEnum {
    export type Labels = (typeof RegistrationStatusEnum)["labels"][number];
    export type Values = (typeof RegistrationStatusEnum)["values"][number];
    export type ValuesOngoing = (typeof RegistrationStatusEnum)["valuesOngoing"][number];
}
